// Import helpers
import { convertPriceToNumberFormat } from 'helpers/prices';

// Import types
import { PacketStatus } from 'types/api/packetsSubscription';
import type { Genre } from 'types/api/products/product';
import type { PacketWithPriceAndChannels, SummaryProduct } from 'types/views/configurator';
import type { CurrentProductWithSubtype, UserSubscriptionParsed } from 'types/views/subscription';

export const convertGenresToBrands = (genres: Genre[] | null) => {
	if (!genres) return {};

	return genres.reduce((brands: Record<string, string>, genre, index) => {
		const brandKey = `item_brand${index + 1}`;
		brands[brandKey] = genre.name;
		return brands;
	}, {});
};

export const getPacketsGTMData = (products: Array<PacketWithPriceAndChannels | SummaryProduct>) =>
	products.map((packet) => {
		const price = 'current_price' in packet ? packet.current_price : packet.prices_by_payment_methods?.subscription?.subscription_bluemedia?.price;

		return {
			item_id: packet.uuid,
			item_name: packet.title || '',
			currency: 'PLN',
			item_brand: 'Vectra',
			item_category: `Pakiet ${packet.subtype}`,
			price: convertPriceToNumberFormat(price),
			quantity: 1
		};
	});

export const getUserPacketsGtmData = (products: CurrentProductWithSubtype[]) =>
	products.map(({ product_uuid, name, price, subtype }) => ({
		item_id: product_uuid,
		item_name: name,
		currency: 'PLN',
		item_brand: 'Vectra',
		item_category: `Pakiet ${subtype}`,
		price: convertPriceToNumberFormat(price),
		quantity: 1
	}));

export const getCancelledPackets = (subscription: UserSubscriptionParsed | null, uuid: string) => {
	if (!subscription) return [];
	const isMainCanceled = subscription.main.product_uuid === uuid;
	const packets = subscription.premium.filter(({ status }) => status === PacketStatus.Active);
	return isMainCanceled ? packets.concat(subscription.main) : packets.filter(({ product_uuid }) => product_uuid === uuid);
};
